module.exports = __webpack_public_path__ + "img/galery-kx5600-1.cc85b1b5.png";